import { Button, Input, Modal, Tooltip, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import { cn } from '@/utils/styleUtils.ts';

const NOTIFICATION_MAX_HEIGHT = 500;

// TODO: simplify
const eterno: [string, string, string, string, string, string, string, string, string, string] = [
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
    '#88E59C',
];

export const theme = createTheme({
    fontFamily: 'Uncut-Sans-Regular, sans-serif',
    headings: {
        fontFamily: 'Uncut-Sans-Regular, sans-serif',
    },
    colors: {
        eterno: eterno,
    },
    primaryColor: 'eterno',
    primaryShade: 9,
    defaultRadius: '0.375rem',
    components: {
        Input: Input.extend({
            classNames: {
                input: 'bg-slate-100 disabled:border-transparent disabled:text-slate-400 disabled:opacity-100 disabled:bg-slate-100',
            },
        }),
        Button: Button.extend({
            classNames: {
                root: 'text-font hover:text-black',
            },
        }),
        Tooltip: Tooltip.extend({
            defaultProps: {
                withArrow: true,
            },
        }),
        Notifications: Notifications.extend({
            defaultProps: {
                notificationMaxHeight: NOTIFICATION_MAX_HEIGHT,
            },
        }),
    },
});

export const dark_theme = createTheme({
    fontFamily: 'Uncut-Sans-Regular, sans-serif',
    headings: {
        fontFamily: 'Uncut-Sans-Regular, sans-serif',
    },
    colors: {
        eterno: eterno,
    },
    primaryColor: 'eterno',
    primaryShade: 9,
    defaultRadius: '0.375rem',
    components: {
        Button: Button.extend({
            classNames: (theme, { variant }) => ({
                root: cn(
                    'text-font hover:text-black',
                    variant === 'outline' && 'text-neutral-300 hover:text-neutral-300'
                ),
            }),
        }),
        Tooltip: Tooltip.extend({
            defaultProps: {
                withArrow: true,
            },
        }),
        Modal: Modal.extend({
            classNames: {
                close: 'text-neutral-300 hover:text-neutral-300',
            },
        }),
        Notifications: Notifications.extend({
            defaultProps: {
                notificationMaxHeight: NOTIFICATION_MAX_HEIGHT,
            },
        }),
    },
});
